(function ($) {
    $(function () {
        $('a.back-to-top__link').on('click', function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0
            }, 400);
        });
    });
})(jQuery);
